"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepOmit = void 0;
var tslib_1 = require("tslib");
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var isObject_1 = tslib_1.__importDefault(require("lodash/isObject"));
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
/**
 * Takes an object and removes the specified props in props to remove.
 *
 * @param {Object} inputValue           Object to clean (won't be mutated)
 * @param {Array<String>} propsToRemove Properties/keys to remove from the object
 * @returns {Object}                    Cleaned object
 */
function deepOmit(inputValue, propsToRemove) {
    if (!(0, isObject_1.default)(inputValue))
        return inputValue;
    var value = (0, cloneDeep_1.default)(inputValue);
    var objectToClean = (0, omit_1.default)(value, propsToRemove);
    Object.keys(objectToClean || {}).forEach(function (key) {
        var valueToClean = objectToClean[key];
        if ((0, isArray_1.default)(valueToClean)) {
            objectToClean[key] = valueToClean.map(function (valueItem) { return deepOmit(valueItem, propsToRemove); });
        }
        else if ((0, isObject_1.default)(valueToClean)) {
            objectToClean[key] = deepOmit(valueToClean, propsToRemove);
        }
    });
    return objectToClean;
}
exports.deepOmit = deepOmit;
